"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OrgTokensController", {
    enumerable: true,
    get: function() {
        return OrgTokensController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _passport = require("@nestjs/passport");
const _getHandler = require("~/helpers/getHandler");
const _orgtokenseeservice = require("~/services/org-tokens-ee.service");
const _orgtokensservice = require("~/services/org-tokens.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let OrgTokensController = class OrgTokensController {
    async apiTokenList(req) {
        return await (0, _getHandler.getConditionalHandler)(this.orgTokensService.apiTokenList, this.orgTokensEeService.apiTokenListEE)({
            query: req.query,
            req: req,
            user: req['user']
        });
    }
    async apiTokenCreate(req, body) {
        return await this.orgTokensService.apiTokenCreate({
            apiToken: body,
            user: req['user'],
            req
        });
    }
    async apiTokenDelete(req, tokenId) {
        await this.orgTokensService.apiTokenDelete({
            tokenId,
            user: req['user'],
            req
        });
    }
    constructor(orgTokensService, orgTokensEeService){
        this.orgTokensService = orgTokensService;
        this.orgTokensEeService = orgTokensEeService;
    }
};
_ts_decorate([
    (0, _common.Get)('/api/v1/tokens'),
    (0, _extractidsmiddleware.Acl)('apiTokenList', {
        scope: 'org',
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgTokensController.prototype, "apiTokenList", null);
_ts_decorate([
    (0, _common.Post)('/api/v1/tokens'),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('apiTokenCreate', {
        scope: 'org',
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.ApiTokenReqType === "undefined" ? Object : _nocodbsdk.ApiTokenReqType
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgTokensController.prototype, "apiTokenCreate", null);
_ts_decorate([
    (0, _common.Delete)('/api/v1/tokens/:tokenId'),
    (0, _extractidsmiddleware.Acl)('apiTokenDelete', {
        scope: 'org',
        // allowedRoles: [OrgUserRoles.SUPER],
        blockApiTokenAccess: true
    }),
    _ts_param(0, (0, _common.Req)()),
    _ts_param(1, (0, _common.Param)('tokenId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], OrgTokensController.prototype, "apiTokenDelete", null);
OrgTokensController = _ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, (0, _passport.AuthGuard)('jwt')),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _orgtokensservice.OrgTokensService === "undefined" ? Object : _orgtokensservice.OrgTokensService,
        typeof _orgtokenseeservice.OrgTokensEeService === "undefined" ? Object : _orgtokenseeservice.OrgTokensEeService
    ])
], OrgTokensController);
